module.exports = __webpack_public_path__ + "static/media/grad7.9dc2e45a.jpg";